/* eslint @typescript-eslint/naming-convention: 0 */
import type { MapSourcePage } from '@/wabunka-src/common/utils/googleAnalytics/common/mapSearch';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface MapViewportSearchParams {
  source_page: MapSourcePage;
}

/**
 * 発火タイミング：ユーザー操作（パン・ズーム・クラスタタップ・全体ビューへ戻る）で地図の描画範囲が変わり、
 * ビューポート連動のピン再取得が走った際。初期表示の自動フィットでは発火しない。
 * Dynamic 課金が跳ねる実装になっていないかの監視用。ダッシュボードのブロック⑦で使用（JCAT-4824）。
 */
export const sendGAWabunkaMapViewportSearchEvent = (sourcePage: MapSourcePage) => {
  sendWabunkaGAEvent('map_viewport_search', { source_page: sourcePage });
};
